//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment'
import me from '~/data/me'

export default {
    name: 'FooterElement',

    data(){ return {
        thisYear: moment().format('YYYY'),
        ...me,
    }},

    methods: {

    }


}
